import React, {  useEffect, useState } from "react";
import { Box,  Grid, Stack, Typography } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PageTitle from "../commoncomponents/PageTitle";
import VendorWorkOrderEditForm from "../vendorwebform/VendorWorkOrderEditForm";
import AttachmentsEditForm from "../vendorwebform/AttachmentsEditForm";
import { ErrorChips, SuccessChips, WarningChips } from "../../assets/styled-components/chips";


const VendorStepper = () => {
  
  const location = useLocation();
  const [page, setPage] = useState("Vendor WorkOrder Edit");
  const webFormData = useSelector((state)=>state.vendorWebForm);
  const workOrderNo = webFormData?.respondedDetails?.workOrderNo || "";
  const locationStateValue = location?.state;
  const workOrderId = locationStateValue?.workorderId || "";
  const workOrderType = locationStateValue?.workordertype || "";
  const assetCategroyType = locationStateValue?.serviceDesc || "";
  const categoryType = locationStateValue?.workordercategory || "";
  const categoryTypeId = locationStateValue?.workordercategoryId || "";
  const checkBottomButtons = locationStateValue?.isEditMode || locationStateValue?.isViewMode || "";
  const isViewMode = locationStateValue?.isViewMode || "";
 // const getstatusId = assetCategroyType === "FEMS" ? "femworkorderstatusId" : "bemworkorderstatusId"
  const getstatusId = assetCategroyType === "FEMS" ? location?.state?.femworkorderstatusId : location?.state?.bemworkorderstatusId
  const statusID = webFormData?.workderStatus ||  "";
  const setSubTitle = isViewMode ? "View Work Order" : "Edit Work Order";
  //const statusID = locationStateValue?.updateWorkorderstatus ? locationStateValue?.updateWorkorderstatus : locationStateValue?.[`${getstatusId}`];

  const statusMapping = {
    2: <ErrorChips label= {"Scheduled"} />,
    3: <WarningChips label ={"In Progress"} />,
    10: <WarningChips label ={"In Progress-Outsource"} />,
    4: <SuccessChips label ={"Completed"} />,
    9: <SuccessChips label ={"Completed-Outsource"} />,
    5: <SuccessChips label ={"Closed"} />,
    6: <ErrorChips label ={"Cancelled"} />,
    8: <SuccessChips label ={"Verified"} />,
  };

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[statusID || getstatusId] || null;

  
  const buttonAttributes = [
    {
      currentPageName: "Vendor WorkOrder Edit",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Continue",
      backButtonName: "",
      backButton: false,
      nextPageName: "Attachments & Signature",
      previousPageName: "",
    },
    {
      currentPageName: "Attachments & Signature",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Submit",
      backButtonName: "Back",
      backButton: true,
      nextPageName: "Attachments & Signature",
      previousPageName: "Vendor WorkOrder Edit",
    }
  ]
  const renderPageContent = () => {
    switch (page) {
      case "Vendor WorkOrder Edit":
        return (
          <VendorWorkOrderEditForm
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
            locationState={{ workorderId: workOrderId,workOrderType:workOrderType,serviceType: assetCategroyType, categoryType:categoryType,bottomButtons: checkBottomButtons,categoryId:categoryTypeId,isViewMode:isViewMode,woStatus:statusID }}
          />
        );
      case "Attachments & Signature":
        return (
          <AttachmentsEditForm
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
            locationState={{ workorderId: workOrderId,workOrderType:workOrderType,serviceType: assetCategroyType, categoryType:categoryType,bottomButtons:checkBottomButtons, categoryId:categoryTypeId,isViewMode:isViewMode,woStatus:statusID}}
          />
        );
      
      default:
        return null;
    }
  };
   
  return (
    <>
        <Grid item xs={12} sm={8.6} md={9.8}>
            <PageTitle
                title={"Vendor Work Order"}
            />
            <DefaultCard sx={{ height: "100%" }}>
           
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={"5px"}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 2 }}>
              {workOrderNo} - {setSubTitle}            
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {mappedStatus}
            </Stack>
              {renderPageContent()}
            </DefaultCard>
        </Grid>
        
  </>
  );
}

export default VendorStepper;
